import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
    name: 'appState',
    initialState: {
      buildConfig: "",
      buildVersion: "",
    },
    reducers: {
      updateBuildConfig: (state, action) => {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes
        state.buildConfig = action.payload;
      },
      updateBuildVersion: (state, action) => {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes
        state.buildVersion = action.payload;
      },
    },
  })

  export const { updateBuildConfig, updateBuildVersion} = appSlice.actions;

  export default appSlice.reducer;